const ldApiService = {};

export default ldApiService;
